import React from "react";

const Video = ({ style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36" }) => (
    <svg
        width={size}
        style={style}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            className="u_fill"
            d="M23.818 6c.386 0 .756.152 1.029.423.272.271.426.638.426 1.021v6.067l7.582-5.272a.73.73 0 0 1 1.04.217.719.719 0 0 1 .105.375V26.28a.718.718 0 0 1-.391.641.73.73 0 0 1-.754-.049L25.273 21.6v6.067c0 .383-.154.75-.426 1.021a1.46 1.46 0 0 1-1.029.423H3.455a1.46 1.46 0 0 1-1.029-.423A1.439 1.439 0 0 1 2 27.667V7.444c0-.383.153-.75.426-1.02A1.46 1.46 0 0 1 3.455 6h20.363ZM11.31 12.975a.585.585 0 0 0-.57.462l-.012.115v8.005a.575.575 0 0 0 .512.573c.094.012.189 0 .277-.033l.106-.052 6.334-4.004a.58.58 0 0 0 .233-.685.577.577 0 0 0-.141-.216l-.092-.073-6.334-4.004a.585.585 0 0 0-.313-.086v-.002Z"
            fill={fill}
        />
    </svg>
);

export default Video;


